import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule, MatDialogModule, MatIconModule } from '@angular/material';
import { TranslateModule } from '@ngx-translate/core';
import { ImageCropperModule } from 'ngx-image-cropper';
import { ChangeAvatarComponent } from './change-avatar.component';
import { ChangeAvatarService } from './change-avatar.service';

@NgModule({
  entryComponents: [
    ChangeAvatarComponent
  ],
  imports: [
    CommonModule,
    MatIconModule,
    MatDialogModule,
    MatButtonModule,
    TranslateModule,
    ImageCropperModule
  ],
  declarations: [
    ChangeAvatarComponent
  ],
  exports: [
    ChangeAvatarComponent
  ],
  providers: [
    ChangeAvatarService
  ]
})
export class ChangeAvatarModule {}
